type DiffMap<T> = Record<string, T>;

interface UseDiffStoreProps {
    dirtyClass: string;
    storageKey: string;
}

export const useDiffStore = <T>({
    storageKey,
    dirtyClass
}: UseDiffStoreProps) => {

    const getStoredChanges = (): DiffMap<T> => {
        const raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) as DiffMap<T> : {};
    };

    const persist = (changes: DiffMap<T>) => {
        localStorage.setItem(storageKey, JSON.stringify(changes));
    };

    const addChange = (key: string, value: T): DiffMap<T> => {
        const storedChanges = getStoredChanges();

        storedChanges[key] = value;

        persist(storedChanges);

        const input = document.getElementById(key);
        if (input) {
            input.classList.add(dirtyClass);
        }

        return storedChanges
    };

    const removeChange = (key: string, newValue?: string): DiffMap<T> => {
        const storedChanges = getStoredChanges();

        const { [key]: _, ...rest } = storedChanges;

        persist(rest);

        const input = document.getElementById(key) as HTMLInputElement | null;
        if (input) {
            input.classList.remove(dirtyClass);

            if (newValue) input.value = newValue
        }

        return rest
    };

    const getValue = (key: string): T | undefined => {
        const changes = getStoredChanges();
        return changes[key];
    }

    const commitChanges = () => {
        const keys = Object.keys(getStoredChanges());

        keys.forEach(k => {
            document.getElementById(k)?.classList.remove(dirtyClass);
        })
        localStorage.removeItem(storageKey);
    }

    return {
        getValue,
        addChange,
        removeChange,
        getStoredChanges,
        commitChanges,
    };
};
